import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { NhomQuyenListWrapper } from './nhomquyen-list/NhomQuyenList'
const Breadcrumbs: Array<PageLink> = [
  {
    title: 'Trang chủ',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Quản trị hệ thống',
    path: '#',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Quản lý nhóm quyền',
    path: '#',
    isSeparator: false,
    isActive: false,
  },
]

const NhomQuyenPage = () => {
  document.title = "Quản lý nhóm quyền"
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='danhsach'
          element={
            <>
              <PageTitle breadcrumbs={Breadcrumbs}></PageTitle>
              <NhomQuyenListWrapper />
            </>
          }
        />
      </Route>

      <Route index element={<Navigate to='/quantrihethong/nhomquyen/danhsach' />} />
    </Routes>
  )
}

export default NhomQuyenPage
